import { ErrorMessage, Formik } from "formik";
import Multiselect from "multiselect-react-dropdown";
import { FC, useEffect, useRef, useState } from "react";
import { Form, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import "./form-builder.scss";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faEye,
  faEyeSlash,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import * as _ from "lodash";

import downloadIcon from "../../assets/images/download.svg";
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  B2Button,
  B2Form,
  B2Input,
  B2RadioButton,
  B2Switch,
} from "@hdb/biome-2";
import Select from "react-select";
import RichTextEditor from "../quill-editor/rich-text-editor";
interface ChipsValues {
  [key: string]: any[];
}

interface SublocationChipsValues {
  id: number[];
  sublocation: string[];
}

export interface Control {
  name: string;
  label: string;
  placeholder?: string;
  type:
    | string
    | "text"
    | "textarea"
    | "formatted-textarea"
    | "number"
    | "checkbox"
    | "switch"
    | "date"
    | "datetime"
    | "email"
    | "select"
    | "password"
    | "chips"
    | "file"
    | "searchable-select"
    | "tel";
  required?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  options?: any;
  selectableValue?: string;
  selectedValue?: string;
  onChange?: (selectedValue: any) => void;
  controlId?: string | "formFile";
  display?: boolean;
  suffix?: string;
  minDate?: string;
  maxDate?: string;
  filterFileTypes?: string;
  isLoading?: boolean;
  rows?: number;
  dispatchableApi?: {
    api: string;
    params: any;
    selectableProperty: string;
  };
  chipsValidation?: (value: any) => boolean;
  info?: string;
  onChangeDisable?: (userID: any, text: any) => void;
  disableFormFieldsLabel?: boolean;
  prefix?: string;
  pattern?: string;
  maxLength?: number;
}

export interface FormConfig {
  controls: Control[];
}

interface FormBuilderComponentProps {
  formRef: any;
  formConfig: FormConfig;
  initialValues: any;
  validation: any;
  renderCount?: any;
  fileConfig?: {
    fileName?: string;
    isShowImage: boolean;
    isEdit: boolean;
    preview: any;
    isLink?: boolean;
    onRemoveFile: () => void;
  };
}

const FormBuilderComponent: FC<FormBuilderComponentProps> = ({
  formRef,
  formConfig,
  initialValues,
  validation,
  fileConfig,
  renderCount,
}) => {
  const { controls } = formConfig;
  const dispatch = useDispatch();

  const [chipsValues, setChipsValues] = useState([] as any);

  const [chipsCurrentValue, setChipsCurrentValue] = useState("");
  const [chipsList, setChipsList] = useState([] as any);
  const [showChipsList, setShowChipsList] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  //

  const onChangeMultiSelect = (values: any, setFieldValue: any, name: any) => {
    setFieldValue(name, values);
  };

  const onRemoveMultiSelect = (values: any, setFieldValue: any, name: any) => {
    setFieldValue(name, values);
  };

  const onChangeChipsItem = (
    setFieldValue: any,
    name: any,
    currentValue: any,
    selectableProperty: any,
  ) => {
    let copyChipsValues: any = _.cloneDeep(chipsValues) || [];

    // for free text
    const chipsControl: any = formConfig.controls.find(
      (control: any) => control.type === "chips",
    );

    if (!chipsControl.hasOwnProperty("dispatchableApi")) {
      if (!copyChipsValues?.find((chip: any) => chip === currentValue)) {
        copyChipsValues.push(currentValue);
        setFieldValue(name, copyChipsValues);
        setChipsValues(copyChipsValues);
      }

      return;
    }

    // for selecting options from dispatchableApi
    if (
      !chipsList.find(
        (item: any) =>
          item[selectableProperty] === currentValue || !currentValue?.length,
      )
    )
      return;

    if (
      copyChipsValues?.find(
        (chip: any) =>
          chip[selectableProperty as keyof ChipsValues] === currentValue,
      )
    ) {
      // remove the selected value from the selected items
      copyChipsValues = copyChipsValues.filter(
        (chip: any) =>
          chip[selectableProperty as keyof ChipsValues] !== currentValue,
      );

      setFieldValue(
        name,
        copyChipsValues?.map((chip: any) => chip.id),
      );
      setChipsValues(copyChipsValues);
    }

    // add the selected value to the selected list
    if (
      !copyChipsValues?.find(
        (chip: any) =>
          chip[selectableProperty as keyof ChipsValues] === currentValue,
      )
    ) {
      const foundItem = chipsList?.find(
        (item: any) =>
          item[selectableProperty as keyof ChipsValues] == currentValue,
      );

      copyChipsValues.push(foundItem);

      setFieldValue(
        name,
        copyChipsValues?.map((chip: any) => chip.id),
      );
      setChipsValues(copyChipsValues);
    }
  };

  const onRemoveChipsItem = (index: any, setFieldValue: any, name: any) => {
    let copyChipsValues: any = _.cloneDeep(chipsValues) || [];
    copyChipsValues.splice(index, 1);

    const chipsControl: any = formConfig.controls.find(
      (control: any) => control.type === "chips",
    );

    if (!chipsControl.hasOwnProperty("dispatchableApi")) {
      setFieldValue(name, copyChipsValues);
      setChipsValues(copyChipsValues);
    }

    setFieldValue(
      name,
      copyChipsValues?.map((chip: any) => chip.id),
    );
    setChipsValues(copyChipsValues);
  };

  const getOptionList = (api: any, param: any, value: any) => {
    if (api && param) {
      dispatch(api({ ...param, searchText: value })).then((r: any) => {
        setChipsList(r.payload);
        setShowChipsList(true);
      });
    }
  };

  const searchBoxRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: any) => {
    if (
      searchBoxRef.current &&
      !searchBoxRef.current.contains(event.target as Node)
    ) {
      setShowChipsList(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // for chips

    if (Object.keys(initialValues).length && Object.keys(formConfig).length) {
      const chipsControl: any = formConfig.controls.find(
        (control: any) => control.type === "chips",
      );

      if (!chipsControl?.hasOwnProperty("dispatchableApi")) {
        setChipsValues(initialValues[chipsControl?.name]);
        return;
      }

      if (chipsControl) {
        // pushing the existing values to the selected items
        const values = initialValues[chipsControl.name];

        if (
          chipsControl?.dispatchableApi &&
          Object.values(chipsControl?.dispatchableApi?.params).every(
            (value) => value !== undefined && value !== null,
          ) &&
          !chipsList?.length
        ) {
          dispatch(
            chipsControl?.dispatchableApi?.api({
              ...chipsControl?.dispatchableApi?.params,
              searchText: "",
            }),
          ).then((r: any) => {
            let chipsList = r.payload;
            setChipsList(chipsList);

            if (values?.length) {
              let selectedChips = [];
              for (let value of values) {
                const foundItem = chipsList.find(
                  (chip: any) => chip.id === value,
                );
                if (foundItem) {
                  selectedChips.push(foundItem);
                }
              }
              setChipsValues(selectedChips);
            }
          });
        }
      }

      // setRenderCount(renderCount + 1);
    }
  }, [initialValues, formConfig]);

  return (
    <div>
      {Object.keys(initialValues).length ? (
        <Formik
          key={renderCount || 0}
          innerRef={formRef}
          enableReinitialize
          onSubmit={(values: any) => {}}
          validationSchema={validation}
          initialValues={initialValues}
          validateOnChange={true}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            setFieldTouched,
            setFieldError,
            values,
            touched,
            errors,
          }) => (
            <B2Form noValidate onSubmit={handleSubmit}>
              <div className="">
                {controls?.map((control: any, i: number) => (
                      <div key={i + 0}>
                        {(() => {
                          switch (control.type) {
                            case "text":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                    {control?.info && (
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="ms-2"
                                        title={control?.info}
                                      />
                                    )}
                                  </div>

                                  <div className="">
                                    <B2Form.Group>
                                      <div className="d-flex align-items-center">
                                        <B2Input
                                          type="text"
                                          placeholder={control.placeholder}
                                          name={control.name}
                                          onChange={(e: any) => {
                                            if (control?.onChangeDisable) {
                                              control?.onChangeDisable(
                                                control?.name,
                                                e.target.value,
                                              );
                                            }
                                            setFieldTouched(
                                              control?.name,
                                              true,
                                            );
                                            handleChange(e);
                                            setFieldValue(
                                              control?.name,
                                              e.target.value,
                                            );
                                          }}
                                          value={values[control?.name]}
                                          required={control.required ?? false}
                                          readOnly={control.readOnly ?? false}
                                          disabled={control.disabled ?? false}
                                          isValid={
                                            touched[control.name] &&
                                            !errors[control.name]
                                          }
                                          isInvalid={
                                            (!!touched[control.name] &&
                                              !!errors[control.name]) ??
                                            false
                                          }
                                        />
                                        {control?.isLoading && (
                                          <Spinner
                                            animation="border"
                                            variant="primary"
                                            className="ms-1"
                                            size="sm"
                                          />
                                        )}
                                      </div>
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "email":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                    {control?.info && (
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="ms-2"
                                        title={control?.info}
                                      />
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <B2Input
                                        type="email"
                                        placeholder={control.placeholder}
                                        name={control.name}
                                        onChange={(e: any) => {
                                          if (control?.onChangeDisable) {
                                            control?.onChangeDisable(
                                              control?.name,
                                              e.target.value,
                                            );
                                          }
                                          setFieldTouched(control?.name, true);
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.value,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={control.disabled ?? false}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "password":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                    {control?.info && (
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="ms-2"
                                        title={control?.info}
                                      />
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <div className="d-flex align-items-center gap-2 position-relative ">
                                        <B2Input
                                          type={
                                            showPassword ? "text" : "password"
                                          }
                                          placeholder={control.placeholder}
                                          name={control.name}
                                          onChange={(e: any) => {
                                            setFieldTouched(
                                              control?.name,
                                              true,
                                            );
                                            handleChange(e);
                                            setFieldValue(
                                              control?.name,
                                              e.target.value,
                                            );
                                          }}
                                          value={values[control?.name]}
                                          required={control.required ?? false}
                                          readOnly={control.readOnly ?? false}
                                          disabled={control.disabled ?? false}
                                          isValid={
                                            touched[control.name] &&
                                            !errors[control.name]
                                          }
                                          isInvalid={
                                            (!!touched[control.name] &&
                                              !!errors[control.name]) ??
                                            false
                                          }
                                        />
                                        <button
                                          type="button"
                                          onClick={togglePasswordVisibility}
                                          className="password-toggle-button bg-transparent border-0 position-absolute end-0 me-2"
                                        >
                                          {showPassword ? (
                                            <FontAwesomeIcon
                                              icon={faEyeSlash}
                                            />
                                          ) : (
                                            <FontAwesomeIcon icon={faEye} />
                                          )}
                                        </button>
                                      </div>

                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "tel":
                              return (
                                <div className="flex items-start w-100">
                                  <div className="w-100">
                                    <div className="filter-label mb-2">
                                      {control.label}
                                    </div>
                                    <Form.Group>
                                      {control.prefix && (
                                        <div className="input-group">
                                          <span className="input-group-text">
                                            {control.prefix}
                                          </span>
                                          <Form.Control
                                            type="tel"
                                            placeholder={control.placeholder}
                                            name={control.name}
                                            onChange={handleChange}
                                            onKeyDown={(e) => {
                                              // Allow: backspace, delete, tab, escape, enter, arrow keys
                                              if (
                                                [
                                                  "Backspace",
                                                  "Delete",
                                                  "Tab",
                                                  "Escape",
                                                  "Enter",
                                                  "ArrowLeft",
                                                  "ArrowRight",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                  "Home",
                                                  "End",
                                                ].includes(e.key) ||
                                                // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                                                (e.key === "a" && e.ctrlKey) ||
                                                (e.key === "c" && e.ctrlKey) ||
                                                (e.key === "v" && e.ctrlKey) ||
                                                (e.key === "x" && e.ctrlKey)
                                              ) {
                                                return;
                                              }
                                              // Ensure that it is a number and stop the keypress
                                              if (!/\d/.test(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onPaste={(e) => {
                                              e.preventDefault();
                                              // Strip spaces from pasted text, then check for non-digits
                                              const pastedText =
                                                e.clipboardData.getData("text");
                                              const stripped =
                                                pastedText.replace(/\s/g, "");
                                              if (/^\d*$/.test(stripped)) {
                                                const input =
                                                  e.target as HTMLInputElement;
                                                const start =
                                                  input.selectionStart ??
                                                  input.value.length;
                                                const end =
                                                  input.selectionEnd ??
                                                  input.value.length;
                                                const newValue =
                                                  input.value.slice(0, start) +
                                                  stripped +
                                                  input.value.slice(end);
                                                const truncated =
                                                  control.maxLength
                                                    ? newValue.slice(
                                                        0,
                                                        control.maxLength,
                                                      )
                                                    : newValue;
                                                const newCursorPos = Math.min(
                                                  start + stripped.length,
                                                  truncated.length,
                                                );
                                                setFieldValue(
                                                  control.name,
                                                  truncated,
                                                );
                                                requestAnimationFrame(() => {
                                                  input.selectionStart =
                                                    newCursorPos;
                                                  input.selectionEnd =
                                                    newCursorPos;
                                                });
                                              }
                                            }}
                                            value={values[control?.name]}
                                            maxLength={control.maxLength}
                                            pattern={control.pattern}
                                            required={control.required ?? false}
                                            readOnly={control.readOnly ?? false}
                                            disabled={control.disabled ?? false}
                                            isValid={
                                              touched[control.name] &&
                                              !errors[control.name]
                                            }
                                            isInvalid={
                                              (!!touched[control.name] &&
                                                !!errors[control.name]) ??
                                              false
                                            }
                                          />
                                        </div>
                                      )}
                                      {!control.prefix && (
                                        <Form.Control
                                          type="tel"
                                          placeholder={control.placeholder}
                                          name={control.name}
                                          onChange={handleChange}
                                          onKeyDown={(e) => {
                                            // Allow: backspace, delete, tab, escape, enter, arrow keys
                                            if (
                                              [
                                                "Backspace",
                                                "Delete",
                                                "Tab",
                                                "Escape",
                                                "Enter",
                                                "ArrowLeft",
                                                "ArrowRight",
                                                "ArrowUp",
                                                "ArrowDown",
                                                "Home",
                                                "End",
                                              ].includes(e.key) ||
                                              // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                                              (e.key === "a" && e.ctrlKey) ||
                                              (e.key === "c" && e.ctrlKey) ||
                                              (e.key === "v" && e.ctrlKey) ||
                                              (e.key === "x" && e.ctrlKey)
                                            ) {
                                              return;
                                            }
                                            // Ensure that it is a number and stop the keypress
                                            if (!/\d/.test(e.key)) {
                                              e.preventDefault();
                                            }
                                          }}
                                          onPaste={(e) => {
                                            e.preventDefault();
                                            // Strip spaces from pasted text, then check for non-digits
                                            const pastedText =
                                              e.clipboardData.getData("text");
                                            const stripped = pastedText.replace(
                                              /\s/g,
                                              "",
                                            );
                                            if (/^\d*$/.test(stripped)) {
                                              const input =
                                                e.target as HTMLInputElement;
                                              const start =
                                                input.selectionStart ??
                                                input.value.length;
                                              const end =
                                                input.selectionEnd ??
                                                input.value.length;
                                              const newValue =
                                                input.value.slice(0, start) +
                                                stripped +
                                                input.value.slice(end);
                                              const truncated =
                                                control.maxLength
                                                  ? newValue.slice(
                                                      0,
                                                      control.maxLength,
                                                    )
                                                  : newValue;
                                              const newCursorPos = Math.min(
                                                start + stripped.length,
                                                truncated.length,
                                              );
                                              setFieldValue(
                                                control.name,
                                                truncated,
                                              );
                                              requestAnimationFrame(() => {
                                                input.selectionStart =
                                                  newCursorPos;
                                                input.selectionEnd =
                                                  newCursorPos;
                                              });
                                            }
                                          }}
                                          value={values[control?.name]}
                                          maxLength={control.maxLength}
                                          pattern={control.pattern}
                                          required={control.required ?? false}
                                          readOnly={control.readOnly ?? false}
                                          disabled={control.disabled ?? false}
                                          isValid={
                                            touched[control.name] &&
                                            !errors[control.name]
                                          }
                                          isInvalid={
                                            (!!touched[control.name] &&
                                              !!errors[control.name]) ??
                                            false
                                          }
                                        />
                                      )}
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              );
                            case "number":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                    {control?.info && (
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="ms-2"
                                        title={control?.info}
                                      />
                                    )}
                                  </div>

                                  <div className="d-flex align-items-center w-100">
                                    <div className="w-100">
                                      <B2Form.Group>
                                        <div className="d-flex align-items-center">
                                          <B2Input
                                            type="number"
                                            min="0"
                                            placeholder={control.placeholder}
                                            name={control.name}
                                            onChange={(e: any) => {
                                              handleChange(e);
                                              if (Number(e.target.value) < 0) {
                                                e.target.value = 0;
                                                setFieldValue(control?.name, 0);
                                                setFieldTouched(
                                                  control?.name,
                                                  true,
                                                );
                                                return;
                                              }
                                              setFieldTouched(
                                                control?.name,
                                                true,
                                              );
                                              setFieldValue(
                                                control?.name,
                                                e.target.value,
                                              );
                                            }}
                                            value={values[control?.name]}
                                            required={control.required ?? false}
                                            readOnly={control.readOnly ?? false}
                                            disabled={control.disabled ?? false}
                                            isValid={
                                              touched[control.name] &&
                                              !errors[control.name]
                                            }
                                            isInvalid={
                                              (!!touched[control.name] &&
                                                !!errors[control.name]) ??
                                              false
                                            }
                                          />
                                          {control?.isLoading && (
                                            <Spinner
                                              animation="border"
                                              variant="primary"
                                              className="ms-1"
                                              size="sm"
                                            />
                                          )}
                                        </div>
                                        <ErrorMessage
                                          name={control.name}
                                          component="div"
                                          className="error-message"
                                        />
                                      </B2Form.Group>
                                    </div>
                                    {control.suffix && (
                                      <div
                                        className="mb-2"
                                        style={{
                                          width: "50px",
                                          marginLeft: "1rem",
                                        }}
                                      >
                                        {control.suffix}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            case "textarea":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div
                                    className="textarea-rows-height"
                                    style={
                                      {
                                        "--textarea-height":
                                          (Number.isInteger(control?.rows)
                                            ? (control.rows ?? 3) * 1.2
                                            : 3 * 1.2) + "em",
                                      } as React.CSSProperties
                                    }
                                  >
                                    <B2Form.Group>
                                      <B2Input
                                        as="textarea"
                                        // rows={3}
                                        placeholder={control.placeholder}
                                        name={control.name}
                                        onChange={(e: any) => {
                                          setFieldTouched(control?.name, true);
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.value,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={control.disabled ?? false}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "formatted-textarea":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div
                                    className="textarea-rows-height"
                                    style={
                                      {
                                        "--textarea-height":
                                          (Number.isInteger(control?.rows)
                                            ? (control.rows ?? 3) * 1.2
                                            : 3 * 1.2) + "em",
                                      } as React.CSSProperties
                                    }
                                  >
                                    <B2Form.Group>
                                      {control?.readOnly ? (
                                        <div
                                          className="form-control"
                                          style={{
                                            minHeight: "37.6px",
                                            backgroundColor: "#e9ecef",
                                            overflow: "auto",
                                            cursor: "not-allowed",
                                            pointerEvents: "none",
                                          }}
                                        >
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                initialValues[control?.name] ||
                                                "",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <RichTextEditor
                                          placeholder={control?.placeholder}
                                          name={control?.name}
                                          onChange={(e) => {
                                            setFieldTouched(
                                              control?.name,
                                              true,
                                            );
                                            handleChange(e);
                                            setFieldValue(
                                              control?.name,
                                              e?.target?.value,
                                            );
                                          }}
                                          value={values[control?.name]}
                                          required={control?.required ?? false}
                                          readOnly={control?.readOnly ?? false}
                                          disabled={control?.disabled ?? false}
                                          isValid={
                                            touched[control?.name] &&
                                            !errors[control?.name]
                                          }
                                          isInvalid={
                                            (!!touched[control?.name] &&
                                              !!errors[control?.name]) ??
                                            false
                                          }
                                        />
                                      )}

                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "date":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <B2Input
                                        type="date"
                                        placeholder={control.placeholder}
                                        name={control.name}
                                        onChange={(e: any) => {
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.value,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={control.disabled ?? false}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                        min={control?.minDate || ""}
                                        max={control?.maxDate || ""}
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "datetime":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <B2Input
                                        // className="text-dark"
                                        type="datetime-local"
                                        placeholder={control.placeholder}
                                        name={control.name}
                                        onChange={(e: any) => {
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.value,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={control.disabled ?? false}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                        min={control?.minDate || ""}
                                        max={control?.maxDate || ""}
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "time":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <B2Input
                                        type="time"
                                        placeholder={control.placeholder}
                                        name={control.name}
                                        onChange={(e: any) => {
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.value,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={control.disabled ?? false}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "switch":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <B2Switch
                                        type="switch"
                                        name={control.name}
                                        disabled={
                                          control?.disabled
                                            ? control?.disabled
                                            : false
                                        }
                                        readOnly={
                                          control?.readOnly
                                            ? control?.readOnly
                                            : false
                                        }
                                        onChange={(e: any) => {
                                          //  ;
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.checked,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        checked={values[control?.name]}
                                        defaultChecked={values[control?.name]}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );
                            case "radio":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div className="">
                                    <B2Form.Group>
                                      <B2RadioButton
                                        // type="radio"
                                        name={control.name}
                                        disabled={
                                          control?.disabled
                                            ? control?.disabled
                                            : false
                                        }
                                        readOnly={
                                          control?.readOnly
                                            ? control?.readOnly
                                            : false
                                        }
                                        onChange={(e: any) => {
                                          handleChange(e);
                                          setFieldValue(
                                            control?.name,
                                            e.target.value,
                                          );
                                        }}
                                        value={values[control?.name]}
                                        defaultChecked={values[control?.name]}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </B2Form.Group>
                                  </div>
                                </div>
                              );

                            case "select":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  {!control.disableFormFieldsLabel && (
                                    <div className="mb-2">
                                      {control.label}
                                      {control.required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </div>
                                  )}
                                  <div className="">
                                    <Form.Group
                                      controlId={`validation + ${control.name}`}
                                    >
                                      <div className="d-flex align-items-center">
                                        {/* New code */}
                                        <div className="flex-grow-1">
                                          <Select
                                            classNamePrefix="custom-select"
                                            className={`${
                                              touched[control.name] &&
                                              errors[control.name]
                                                ? "custom-select--error"
                                                : touched[control.name] &&
                                                    !errors[control.name]
                                                  ? "custom-select--success"
                                                  : ""
                                            }`}
                                            name={control.name}
                                            options={control.options}
                                            onChange={(selectedOption) => {
                                              // Create a synthetic event for Formik compatibility
                                              const syntheticEvent = {
                                                target: {
                                                  name: control.name,
                                                  value:
                                                    selectedOption?.value || "",
                                                },
                                              };
                                              handleChange(syntheticEvent);

                                              if (control.onChange) {
                                                control.onChange(
                                                  selectedOption?.value || "",
                                                );
                                              }
                                            }}
                                            value={
                                              (values[control?.name] &&
                                                control.options?.find(
                                                  (option: any) =>
                                                    option.value ===
                                                    values[control?.name],
                                                )) ||
                                              null
                                            }
                                            placeholder={control?.placeholder}
                                            noOptionsMessage={() =>
                                              control?.placeholder
                                            }
                                            isDisabled={
                                              control.disabled ?? false
                                            }
                                            isSearchable={false}
                                            maxMenuHeight={280}
                                            menuPlacement="auto"
                                          />
                                        </div>
                                        {/* New code */}

                                        {/* Old code */}
                                        {/* <Form.Select
                                          name={control.name}
                                          onChange={(event) => {
                                            handleChange(event);
                                            if (control.onChange) {
                                              control.onChange(
                                                event.target.value
                                              );
                                            }
                                          }}
                                          value={values[control?.name]}
                                          required={control.required ?? false}
                                          disabled={control.disabled ?? false}
                                          isValid={
                                            touched[control.name] &&
                                            !errors[control.name]
                                          }
                                          isInvalid={
                                            (!!touched[control.name] &&
                                              !!errors[control.name]) ??
                                            false
                                          }
                                        >
                                          {control?.placeholder && (
                                            <option value={""}>
                                              {control.placeholder}
                                            </option>
                                          )}

                                          {control.options?.map(
                                            (option: any, index: any) => (
                                              <option
                                                key={index}
                                                value={option?.value}
                                              >
                                                {option.label}
                                              </option>
                                            )
                                          )}
                                        </Form.Select> */}
                                        {/* Old code */}

                                        {control?.isLoading && (
                                          <Spinner
                                            animation="border"
                                            variant="primary"
                                            className="ms-1"
                                            size="sm"
                                          />
                                        )}
                                      </div>
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              );

                            case "multiselect":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>

                                  <div className="position-relative">
                                    <Multiselect
                                      options={control.options}
                                      selectedValues={values[control?.name]}
                                      disable={control?.disabled}
                                      className={`${control?.disabled ? "multiselectDisabled" : ""} ${
                                        control?.disabled &&
                                        (!values[control?.name] ||
                                          values[control?.name].length === 0)
                                          ? "multiselectEmptyDisabled"
                                          : ""
                                      }`}
                                      onSelect={(values) => {
                                        onChangeMultiSelect(
                                          values,
                                          setFieldValue,
                                          control.name,
                                        );
                                        if (control?.onChange) {
                                          control.onChange(values);
                                        }
                                      }}
                                      onRemove={(values) => {
                                        onRemoveMultiSelect(
                                          values,
                                          setFieldValue,
                                          control.name,
                                        );
                                        if (control?.onChange) {
                                          control.onChange(values);
                                        }
                                      }}
                                      displayValue="label"
                                    />

                                    {/* ✅ Custom placeholder */}
                                    {control?.disabled &&
                                      (!values[control?.name] ||
                                        values[control?.name].length === 0) && (
                                        <div className="multiselect-placeholder">
                                          No site is assigned
                                        </div>
                                      )}

                                    <ErrorMessage
                                      name={control.name}
                                      component="div"
                                      className="error-message"
                                    />
                                  </div>
                                </div>
                              );

                            case "file":
                              return fileConfig?.isShowImage ? (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                    {control?.info && (
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="ms-2"
                                        title={control?.info}
                                      />
                                    )}
                                  </div>
                                  <div className="">
                                    <div style={{ position: "relative" }}>
                                      {fileConfig?.isLink ? (
                                        <B2Button
                                          href={fileConfig?.preview}
                                          variant="default"
                                        >
                                          <img
                                            className="fs-7 me-2"
                                            src={downloadIcon}
                                            alt="Download Icon"
                                          />
                                          {fileConfig?.fileName
                                            ? fileConfig?.fileName
                                            : "Filename not available"}
                                        </B2Button>
                                      ) : (
                                        <img
                                          src={initialValues?.picture}
                                          alt={
                                            fileConfig?.fileName
                                              ? fileConfig?.fileName
                                              : control.name
                                          }
                                          className="image-size"
                                        />
                                      )}

                                      {fileConfig?.isEdit && (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={
                                            <Tooltip>Remove Image</Tooltip>
                                          }
                                        >
                                          <button
                                            className="close-icon"
                                            onClick={() =>
                                              fileConfig?.onRemoveFile()
                                            }
                                          >
                                            <span className="icon">
                                              &times;
                                            </span>
                                          </button>
                                        </OverlayTrigger>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                    {control?.info && (
                                      <FontAwesomeIcon
                                        icon={faCircleInfo}
                                        className="ms-2"
                                        title={control?.info}
                                      />
                                    )}
                                  </div>
                                  <div className="">
                                    <Form.Group>
                                      <Form.Control
                                        type="file"
                                        accept={control?.filterFileTypes}
                                        placeholder={control.placeholder}
                                        name={control.name}
                                        onChange={(event: any) => {
                                          handleChange(event);
                                          if (control.onChange) {
                                            control.onChange(event);
                                          }

                                          if (
                                            control?.name &&
                                            event?.currentTarget?.files.length >
                                              0
                                          ) {
                                            setFieldValue(
                                              control?.name,
                                              event?.currentTarget?.files[0],
                                            );
                                          }
                                        }}
                                        // value=""
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={control.disabled ?? false}
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      {/* {fileConfig?.preview && (
                                        // <img
                                        //   src={fileConfig?.preview}
                                        //   alt="preview"
                                        //   className="image-size"
                                        // />
                                      )} */}
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              );

                            case "chips":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  <div className="mb-2">
                                    {control.label}
                                    {control.disabled}

                                    {control.required && (
                                      <span className="text-danger">*</span>
                                    )}
                                  </div>
                                  <div
                                    className="w-100"
                                    style={{ position: "relative" }}
                                  >
                                    <Form.Group>
                                      <Form.Control
                                        type="text"
                                        autoComplete="off"
                                        placeholder={control.placeholder}
                                        name="chipsControl"
                                        onClick={() => setShowChipsList(true)}
                                        onChange={(event: any) => {
                                          setChipsCurrentValue(
                                            event.target.value,
                                          );
                                          if (event.target.value === "") {
                                            setFieldError(control.name, "");
                                          }
                                          getOptionList(
                                            control.dispatchableApi?.api,
                                            control.dispatchableApi?.params,
                                            event.target.value,
                                          );
                                        }}
                                        onKeyUp={(event: any) => {
                                          if (event.key === "Enter") {
                                            if (
                                              control?.chipsValidation &&
                                              !control?.chipsValidation(
                                                chipsCurrentValue,
                                              )
                                            ) {
                                              setFieldError(
                                                control.name,
                                                `${control.name} is invalid. Phone number must start with +65, followed by 6, 8, or 9, and contain exactly 8 digits.`,
                                              );
                                              return;
                                            }
                                            setChipsCurrentValue("");
                                            onChangeChipsItem(
                                              setFieldValue,
                                              control.name,
                                              chipsCurrentValue,
                                              control.dispatchableApi
                                                ?.selectableProperty,
                                            );
                                          }
                                        }}
                                        value={chipsCurrentValue}
                                        required={control.required ?? false}
                                        readOnly={control.readOnly ?? false}
                                        disabled={
                                          control.disabled ?? false
                                        }
                                        isValid={
                                          touched[control.name] &&
                                          !errors[control.name]
                                        }
                                        isInvalid={
                                          (!!touched[control.name] &&
                                            !!errors[control.name]) ??
                                          false
                                        }
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message"
                                      />
                                    </Form.Group>

                                    {/* showing the selected values */}
                                    {chipsValues?.length ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "1rem",
                                          flexWrap: "wrap",
                                          marginTop: "1rem",
                                        }}
                                      >
                                        {chipsValues.map(
                                          (chip: any, index: any) => (
                                            <div
                                              key={index + 0}
                                              style={{
                                                backgroundColor: "#75ADE4",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                padding: ".3rem .7rem",
                                                borderRadius: "10px",
                                              }}
                                            >
                                              {control?.dispatchableApi
                                                ?.selectableProperty
                                                ? chip[
                                                    control.dispatchableApi
                                                      .selectableProperty
                                                  ]
                                                : chip}

                                              {!control.disabled ? (
                                                <button
                                                  type="button"
                                                  style={{
                                                    cursor: "pointer",
                                                    padding: 0,
                                                    border: "none",
                                                    backgroundColor: "transparent",
                                                  }}
                                                  onClick={(e) => {
                                                    onRemoveChipsItem(
                                                      index,
                                                      setFieldValue,
                                                      control.name,
                                                    );
                                                  }}
                                                >
                                                  <FontAwesomeIcon
                                                    icon={faTimes}
                                                    className="fs-7 ms-2"
                                                  />
                                                </button>
                                              ) : null}
                                            </div>
                                          ),
                                        )}
                                      </div>
                                    ) : null}

                                    {/* showing options list */}
                                    {chipsList?.length && showChipsList ? (
                                      <div
                                        ref={searchBoxRef}
                                        className="bg-card shadow-sm"
                                        style={{
                                          position: "absolute",
                                          top: "38px",
                                          width: "100%",
                                          padding: "1rem",
                                          maxHeight: "300px",
                                          overflowY: "auto",
                                        }}
                                      >
                                        {chipsList?.map((chip: any, index: number) => (
                                          <button
                                            key={index + 0}
                                            type="button"
                                            onClick={() =>
                                              onChangeChipsItem(
                                                setFieldValue,
                                                control.name,
                                                control.dispatchableApi
                                                  ?.selectableProperty
                                                  ? chip[
                                                      control.dispatchableApi
                                                        ?.selectableProperty
                                                    ]
                                                  : "",
                                                control.dispatchableApi
                                                  ?.selectableProperty,
                                              )
                                            }
                                            style={{
                                              padding: "0.5rem 1rem",
                                              cursor: "pointer",
                                              color:
                                                control?.dispatchableApi
                                                  ?.selectableProperty &&
                                                chipsValues?.find(
                                                  (item: any) =>
                                                    item[
                                                      control.dispatchableApi
                                                        ?.selectableProperty as keyof typeof item
                                                    ] ===
                                                    chip[
                                                      control.dispatchableApi
                                                        ?.selectableProperty as keyof typeof item
                                                    ],
                                                )
                                                  ? "#64c8c8"
                                                  : "",
                                                border: "none",
                                                backgroundColor: "transparent",
                                            }}
                                          >
                                            {control.dispatchableApi
                                              ?.selectableProperty
                                              ? chip[
                                                  control.dispatchableApi
                                                    ?.selectableProperty
                                                ]
                                              : "No Items"}
                                          </button>
                                        ))}
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              );

                            case "searchable-select":
                              return (
                                <div
                                  className={`flex flex-column mt-3 mb-3 ${
                                    control.hasOwnProperty("display") &&
                                    !control.display
                                      ? "d-none"
                                      : ""
                                  }`}
                                >
                                  {!control.disableFormFieldsLabel && (
                                    <div className="mb-2">
                                      {control.label}
                                      {control.required && (
                                        <span className="text-danger">*</span>
                                      )}
                                    </div>
                                  )}
                                  <div>
                                    <Form.Group
                                      controlId={`searchable-select-${control.name}`}
                                    >
                                      <Select
                                        options={control.options}
                                        value={control.options?.find(
                                          (option: any) =>
                                            option.value ===
                                            values[control.name],
                                        )}
                                        onChange={(selectedOption: any) => {
                                          setFieldValue(
                                            control.name,
                                            selectedOption?.value || "",
                                          );
                                          if (control.onChange) {
                                            control.onChange(
                                              selectedOption?.value,
                                            );
                                          }
                                        }}
                                        onBlur={() => {
                                          // Handle blur if needed
                                        }}
                                        placeholder={
                                          control.placeholder ||
                                          `Select ${control.label}...`
                                        }
                                        isDisabled={control.disabled}
                                        isSearchable={true}
                                        maxMenuHeight={280}
                                        styles={{
                                          control: (base: any, state: any) => ({
                                            ...base,
                                            borderColor:
                                              touched[control.name] &&
                                              errors[control.name]
                                                ? "#dc3545"
                                                : touched[control.name] &&
                                                    !errors[control.name]
                                                  ? "#198754"
                                                  : "#ced4da",
                                            backgroundColor: state.isDisabled
                                              ? "#e9ecef"
                                              : base.backgroundColor,
                                            color: "#212529",
                                          }),
                                          singleValue: (
                                            base: any,
                                            state: any,
                                          ) => ({
                                            ...base,
                                            color: "#212529",
                                          }),
                                          placeholder: (
                                            base: any,
                                            state: any,
                                          ) => ({
                                            ...base,
                                            color: state.isDisabled
                                              ? "#212529"
                                              : "#6c757d",
                                          }),
                                          input: (base: any, state: any) => ({
                                            ...base,
                                            color: "#212529",
                                          }),
                                          dropdownIndicator: (
                                            base: any,
                                            state: any,
                                          ) => ({
                                            ...base,
                                            color: "#212529",
                                            fontSize: "14px",
                                            transform: "scale(0.8)",
                                          }),
                                        }}
                                      />
                                      <ErrorMessage
                                        name={control.name}
                                        component="div"
                                        className="error-message mt-1"
                                      />
                                    </Form.Group>
                                  </div>
                                </div>
                              );

                            default:
                              return null;
                          }
                        })()}
                      </div>
                    ))
                }
              </div>
            </B2Form>
          )}
        </Formik>
      ) : null}
    </div>
  );
};

export default FormBuilderComponent;
